import React from 'react'
import {Text} from '../../vanilla'
import {useCustomerStore, useContentStore} from '../../store/hooks/useStore'
import {Link} from '../link'
import {DefaultContentBody} from 'dc-delivery-sdk-js'
import {linkUtilityMenu} from '../header/styles.css'
import { observer } from 'mobx-react'
import { FooterLinkContent } from '../../types/cms/footer'
interface FooterLinkProps {
  linkNode: FooterLinkContent
}
export const FooterLink = observer(({linkNode}: FooterLinkProps) => {

  const {isRegistered} = useCustomerStore()
  const ContentStore = useContentStore()

  let asset = null
  let path = null

  // Break the linkNode down to the relevant data for render
  const externalUrl = linkNode.content.externalURL || null
  const deliveryId = linkNode.content._meta.deliveryId
  const navDisplayName = linkNode.content.menuDefinition?.navDisplayName || ''
  const showInMenu = linkNode.content.menuDefinition?.showInMenu || false
  const menuTextColor = linkNode.content.menuDefinition?.menuTextColor || {color: '#000000'}

  // Get the Asset from the store if it exists
  if(!externalUrl && linkNode.content.route){
    asset = ContentStore.contentById[linkNode.content.route.id] as DefaultContentBody
    path = asset.path
  }
  // If the user is not registered, we should redirect to the login page
  if (path === '/account') {
    if (!isRegistered) {
      path = '/login'
    }
  }

  return showInMenu ? (
      <Text
        variant="text1"
        lineHeight="short"
        key={deliveryId}
        as={path || externalUrl ? Link : 'span'}
        className={linkUtilityMenu}
        {...(path ? {to: path} : {})}
        {...(externalUrl ? {href: externalUrl} : {})}
        style={{
          color: menuTextColor?.color || '#000',
        }}
      >
        {navDisplayName}
      </Text>
  ) : null
})
